import ky from "ky";
import { gatherRequestReturn } from "./gatherRequestReturn";

const _auth = { header: "" };

const httpClient = ky.create({
	prefix: import.meta.env.VITE_API_URL,
	timeout: 15_000,
	hooks: {
		beforeRequest: [
			({ request }) => {
				if (_auth.header) {
					request.headers.set("Authorization", _auth.header);
				}
			},
		],
	},
});

async function request(method, url, payload, options) {
	try {
		const hasBody = payload !== undefined;
		const kyOptions = hasBody ? { json: payload, ...options } : options;
		const response = await httpClient[method](url, kyOptions);
		const data = await response.json();

		return gatherRequestReturn({ isError: false, response: data, status: response.status });
	} catch (error) {
		const status = error.response?.status ?? 0;
		const body = error.data ?? { message: error.message ?? "Unknown error" };

		return gatherRequestReturn({ isError: true, response: body, status });
	}
}

const wrapper = {
	baseUrl: import.meta.env.VITE_API_URL,
	timeout: 15_000,

	set headers(value) {
		_auth.header = value.Authorization || "";
	},

	get headers() {
		return {
			get Authorization() {
				return _auth.header;
			},
			set Authorization(value) {
				_auth.header = value;
			},
		};
	},

	get: (url, options) => request("get", url, undefined, options ?? {}),
	post: (url, payload, options) => request("post", url, payload, options ?? {}),
	put: (url, payload, options) => request("put", url, payload, options ?? {}),
	patch: (url, payload, options) => request("patch", url, payload, options ?? {}),
	delete: (url, options) => request("delete", url, undefined, options ?? {}),
};

export default wrapper;
